import { Card } from "primereact/card"
import { useParams } from "react-router-dom"

import JobForm from "../components/JobForm"

interface JobViewProps {
}

const JobView = (props: JobViewProps) => {
  const { jobId } = useParams<{ jobId: string }>()

  return (
    <div>
      <JobForm submitButtonLabel="View" editable={false} />
    </div>
  )
}

export default JobView

